/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TeamPlannerUserDtoPage } from '../../models/team-planner-user-dto-page';

export interface ListTeamPlannerUsersAdded$Params {
  teamPlannerId: string;
  query?: string;
  offset?: number;
  limit?: number;
  sorting?: Array<'id' | '-id' | 'firstName' | '-firstName' | 'lastName' | '-lastName' | 'color' | '-color' | 'isEnabled' | '-isEnabled' | 'memberId' | '-memberId'>;
}

export function listTeamPlannerUsersAdded(http: HttpClient, rootUrl: string, params: ListTeamPlannerUsersAdded$Params, context?: HttpContext): Observable<StrictHttpResponse<TeamPlannerUserDtoPage>> {
  const rb = new RequestBuilder(rootUrl, listTeamPlannerUsersAdded.PATH, 'get');
  if (params) {
    rb.query('teamPlannerId', params.teamPlannerId, {});
    rb.query('query', params.query, {});
    rb.query('offset', params.offset, {});
    rb.query('limit', params.limit, {});
    rb.query('sorting', params.sorting, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<TeamPlannerUserDtoPage>;
    })
  );
}

listTeamPlannerUsersAdded.PATH = '/v0/teamPlanners/{id}/users-added';
